import { GetListResponse, Transaction, TransactionHistory } from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _TransactionService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Transaction>>(
      "/user/api/v1/purchases",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getTransactionHistories(signal?: Signal) {
    return HttpService.get<GetListResponse<TransactionHistory>>(
      "/user/api/v1/purchase",
      {
        signal,
      }
    );
  }

  public confirm(purchaseId: number) {
    return HttpService.post(
      `/user/api/v1/purchases/confirm/${purchaseId}?force=false`
    );
  }
}

const TransactionService = new _TransactionService();

export default TransactionService;
